import {
  leadsOpportunitiesListQueryKey,
  opportunitiesDestroyMutation,
  opportunitiesListQueryKey,
  opportunitiesPipelineListQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'

import { useMutation } from '@tanstack/react-query'

import { App } from 'antd'

import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { ActionsType } from './types'

export const DeleteOpportunity = ({
  opportunity,
  onCancel,
  ...props
}: ActionsType) => {
  const { t } = useTranslation()

  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { notification } = App.useApp()

  const { id: leadId } = useParams()

  const { mutate, isPending } = useMutation({
    ...opportunitiesDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsOpportunitiesListQueryKey({ path: { lead_id: String(leadId) } }),
        opportunitiesListQueryKey(),
        opportunitiesPipelineListQueryKey()
      ])

      notification.success({
        message: t('success.success'),
        description: t('success.success_data_delete')
      })

      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const onDelete = () => {
    if (!opportunity.id) return

    mutate({ path: { id: opportunity.id } })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={onDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
